import { useEffect, useState } from "react";
import { navItems } from "@/mocks/siteContent";

export default function SiteNavbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 lg:px-12 flex items-center justify-between h-16">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-book-marked-line text-lg"></i>
          </span>
          <span className="font-heading font-bold text-foreground-950 text-base md:text-lg whitespace-nowrap">
            夏目彩春 · 动态追踪
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className="px-3 py-2 rounded-md text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setOpen(false)}
                className="px-3 py-2 rounded-md text-sm text-foreground-700 bg-background-100 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}